var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Button, Card, CardContent, CircularProgress, Stack, } from "@mui/material";
import React, { useMemo } from "react";
import { useAsyncCallback } from "react-async-hook";
import { ErrorAlert } from "../ErrorAlert";
import { CloseIcon, SaveIcon, SuccessIcon } from "../icons";
import { useFlag } from "../utils";
export function EditForm({ children, loading, onSave, onCancel, CardProps, CardContentProps, labels }) {
    const [saved, setSaved, clearSaved] = useFlag(false);
    const { loading: saving, error, execute: save } = useAsyncCallback((e) => __awaiter(this, void 0, void 0, function* () {
        e.preventDefault();
        clearSaved();
        yield onSave();
        setSaved();
    }));
    const pending = loading || saving;
    const icon = useMemo(() => {
        if (pending) {
            return React.createElement(CircularProgress, { size: 16, sx: { mx: 0.25 } });
        }
        if (saved) {
            return React.createElement(SuccessIcon, { fontSize: "small" });
        }
        return React.createElement(SaveIcon, null);
    }, [pending, saved]);
    return (React.createElement(Card, Object.assign({}, CardProps),
        React.createElement("form", { onSubmit: save, onChange: clearSaved },
            children,
            error && (React.createElement(CardContent, Object.assign({}, CardContentProps),
                React.createElement(ErrorAlert, { error: error }))),
            React.createElement(CardContent, Object.assign({}, CardContentProps),
                React.createElement(Stack, { direction: "row", spacing: 2 },
                    React.createElement(Button, { type: "submit", variant: "outlined", disabled: pending, startIcon: icon, color: saved ? "success" : "primary" }, labels("save")),
                    onCancel && (React.createElement(Button, { variant: "outlined", disabled: pending, startIcon: React.createElement(CloseIcon, null), onClick: onCancel }, labels("cancel"))))))));
}
//# sourceMappingURL=EditForm.js.map